import styled from 'styled-components';

import { USPBlockWrapperStyled } from './USPBlock.types';

export const USPBlockWrapper = styled.div<USPBlockWrapperStyled>`
  width: 100%;
  padding: 2rem;
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.white};

  display: ${({ gapSpacing }) => (gapSpacing ? 'flex' : 'unset')};
  flex-direction: ${({ gapSpacing }) => (gapSpacing ? 'column' : 'unset')};
  gap: ${({ gapSpacing }) => gapSpacing ?? undefined};
  padding-block: ${({ verticalPaddingMobile }) => verticalPaddingMobile ?? undefined};
  padding-inline: ${({ inlinePaddingMobile }) => inlinePaddingMobile ?? undefined};

  ${({ theme }) => theme.mediaQuery.sm} {
    padding: ${({ desktopPadding }) => desktopPadding ?? '4rem'};
    max-width: 63.3rem;
  }
`;

export const USPBlockTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const IconWrapper = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  flex-shrink: 0;
`;

export const USPBlockItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4rem;
`;

export const USPBlockDescriptionWrapper = styled.div`
  margin-top: 4rem;
`;
